// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "HomePage" + "." + "3b8551c8" + ".chunk.css";
};